import issueRootCausesDefinitionsReducer from './issueRootCausesDefinitions-reducer';

export default (state = {}, action) => ({
  definitions: issueRootCausesDefinitionsReducer(state.definitions, action)
});
